const FacultyData = [
  {
    value: "Nanyang Business School (NBS)",
    label: "Nanyang Business School (NBS)"
  },
  {
    value: "School Electrical and Electronic Engineering (EEE)",
    label: "School Electrical and Electronic Engineering (EEE)"
  },
  {
    value: "School of Civil and Environmental Engineering (CEE)",
    label: "School of Civil and Environmental Engineering (CEE)"
  },
  {
    value: "School of Computer Science and Engineering (SCSE)",
    label: "School of Computer Science and Engineering (SCSE)"
  },
  {
    value: "School of Chemical and Biomedical Engineering (SCBE)",
    label: "School of Chemical and Biomedical Engineering (SCBE)"
  },
  {
    value: "School of Materials Science and Engineering (MSE)",
    label: "School of Materials Science and Engineering (MSE)"
  },
  {
    value: "School of Mechanical and Aerospace Engineering (MAE)",
    label: "School of Mechanical and Aerospace Engineering (MAE)"
  },
  { value: "School of Humanities (SOH)", label: "School of Humanities (SOH)" },
  {
    value: "Wee Kim Wee School of Communication and Information (WKWSCI)",
    label: "Wee Kim Wee School of Communication and Information (WKWSCI)"
  },
  {
    value: "School of Art, Design and Media (ADM)",
    label: "School of Art, Design and Media (ADM)"
  },
  {
    value: "School of Social Sciences (SSS)",
    label: "School of Social Sciences (SSS)"
  },
  {
    value: "School of Physical and Mathematical Sciences (SPMS)",
    label: "School of Physical and Mathematical Sciences (SPMS)"
  },
  {
    value: "The Asian School of the Environment (ASE)",
    label: "The Asian School of the Environment (ASE)"
  },
  {
    value: "School of Biological Sciences (SBS)",
    label: "School of Biological Sciences (SBS)"
  },
  {
    value: "Lee Kong Chian School of Medicine (LKCM)",
    label: "Lee Kong Chian School of Medicine (LKCM)"
  },
  {
    value: "National Institute of Education (NIE)",
    label: "National Institute of Education (NIE)"
  },
  {
    value: "Institute of Science and Technology for Humanity (NISTH)",
    label: "Institute of Science and Technology for Humanity (NISTH)"
  },
  {
    value: "Renaissance Engineering Programme (REP)",
    label: "Renaissance Engineering Programme (REP)"
  },
  {
    value: "University Scholars Programme (USP)",
    label: "University Scholars Programme (USP)"
  },
  {
    value: "C N Yang Scholars Programme",
    label: "C N Yang Scholars Programme"
  },
  {
    value: "Centre for Teaching, Learning & Pedagogy (CTLP)",
    label: "Centre for Teaching, Learning & Pedagogy (CTLP)"
  },
  {
    value: "SkillsFuture Work-Study Degree Programmes (WSDPs)",
    label: "SkillsFuture Work-Study Degree Programmes (WSDPs)"
  },
];

export default FacultyData;
